import { Outlet } from 'react-router-dom';
import { ROUTES } from 'constants/routes';

import DashboardLayout from '@layouts/dashboardLayout/Dashboard.layout';
import CustomerDeliveryDownloadFilesPage from 'pages/operation-history/customer-delivery-download-files';
import ExternalDeliveryDownloadFilesPage from 'pages/operation-history/external-delivery-download-files';
import WithAuth from 'shared/components/hocs/with-auth';

export const OPERATION_HISTORY_ROUTES = {
  path: ROUTES.OPERATION_HISTORY.ROOT,
  element: (
    <WithAuth>
      <Outlet />
    </WithAuth>
  ),
  children: [
    {
      path: ROUTES.OPERATION_HISTORY.CUSTOMER_DELIVERY_DOWNLOAD_FILES.path,
      element: (
        <DashboardLayout>
          <CustomerDeliveryDownloadFilesPage />
        </DashboardLayout>
      ),
    },
    {
      path: ROUTES.OPERATION_HISTORY.EXTERNAL_DELIVERY_DOWNLOAD_FILES.path,
      element: (
        <DashboardLayout>
          <ExternalDeliveryDownloadFilesPage />
        </DashboardLayout>
      ),
    },
  ],
};
